export const sanitizeRate = (rate: string | null) => {
  if (!rate) return rate;
  const DAGGER = '†';
  const ENCODED_DAGGER = '%E2%80%A0';
  return rate.replace(new RegExp(`(${DAGGER}|${ENCODED_DAGGER})$`), '');
};
